export const events = {
  CHECKOUT: "checkout",
  PURCHASE: "purchase",
  ORDER_CREATED: "order_created",
  DIRECT_PAY_ORDER_CREATED: "direct_pay_order_created",
  ORDER_UPDATED: "order_updated",
  ORDER_REDONE: "order_redone",
  VIEW_VERIFY_PAGE: "view_verify_page",
  CLICK_PURCHASE: "click_purchase",
  CLICK_VERIFY_PAGE: "click_verify_button",
  CLICK_FINANCING: "click_financing",
  CLICK_ACCEPT_PAYMENT: "click_accept_payment",
  CARD_DETAILS_UPDATED: "card_details_updated",
};
